<template>
    <div class="app-container">
        <div class="filter-container">
            <el-select class="filter-item" v-model="listQuery.querymodel.cmd_user_id" placeholder="请选择操作人" filterable
                @change="getList()" :clearable="true">
                <el-option v-for="item in emplist" :key="item.Id" :label="item.EmpName" :value="item.Id">
                </el-option>
            </el-select>
            <el-select class="filter-item" v-model="listQuery.querymodel.auth_cmdtype" @change="authcmdtypechange"
                :clearable="true" placeholder="请选择操作类型">
                <el-option label="开启道闸" :value="1"></el-option>
                <el-option label="免单二维码" :value="2"></el-option>
                <el-option label="删除停车记录" :value="3"></el-option>
            </el-select>
            <el-date-picker @change="datechange" :clearable="false" class="filter-item" v-model="querydate"
                type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <!-- <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="收银员姓名/工号"
                style="width: 200px" @keyup.enter.native="getList()" /> -->
            <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        </div>
        <el-table class="app-table" :data="list" border fit highlight-current-row stripe style="width: 100%"
            :height="getViewHeight()" :header-cell-style="{ background: '#F3F4F7', color: '#555' }"
            :row-style="{ height: '10px' }" :cell-style="{ padding: '7px 0' }">
            <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align"
                :prop="col.value" :type="col.type" :width="col.width">
            </el-table-column>
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
            @pagination="getList" />
    </div>
</template>
<style scoped></style>
<script>
import { MrYangUtil } from "../../utils/time.js";
import { getauthlogmv } from "@/api/sysdev";
import { queryemp } from "@/api/employee";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
export default {
    components: { Pagination, Toolbar },
    directives: { waves },
    data() {
        return {
            dialogshow: false,
            tabletypelist: [],
            emplist: [],
            tablelist: [],
            isedit: false,
            buttonList: [],
            downloadLoading: false,
            list: [],
            pageIndex: 1,
            total: 0,
            authunsettle: false,
            detailviewId: "",
            orderrecordmain: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: "今天",
                        onClick(picker) {
                            const end = new Date();
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            const start = new Date();
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            picker.$emit("pick", [start, end, 1]);
                        },
                    },
                    {
                        text: "昨天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            picker.$emit("pick", [start, end, 1]);
                        },
                    },
                    {
                        text: "本周",
                        onClick(picker) {
                            let s = MrYangUtil.getCurrentWeek()[0];
                            s.setHours(0);
                            s.setMinutes(0);
                            s.setSeconds(0);
                            let e = MrYangUtil.getCurrentWeek()[1];
                            e.setHours(23);
                            e.setMinutes(59);
                            e.setSeconds(59);
                            picker.$emit("pick", [s, e, 1]);
                        },
                    },
                    {
                        text: "本月",
                        onClick(picker) {
                            let s = MrYangUtil.getCurrentMonth()[0];
                            s.setHours(0);
                            s.setMinutes(0);
                            s.setSeconds(0);
                            let e = MrYangUtil.getCurrentMonth()[1];
                            e.setHours(23);
                            e.setMinutes(59);
                            e.setSeconds(59);
                            picker.$emit("pick", [s, e, 1]);
                        },
                    },
                    {
                        text: "上月",
                        onClick(picker) {
                            let s = MrYangUtil.getPreviousMonth()[0];
                            s.setHours(0);
                            s.setMinutes(0);
                            s.setSeconds(0);
                            let e = MrYangUtil.getPreviousMonth()[1];
                            e.setHours(23);
                            e.setMinutes(59);
                            e.setSeconds(59);
                            picker.$emit("pick", [s, e, 1]);
                        },
                    },
                    {
                        text: "本年",
                        onClick(picker) {
                            let s = MrYangUtil.getCurrentYear()[0];
                            s.setHours(0);
                            s.setMinutes(0);
                            s.setSeconds(0);
                            let e = MrYangUtil.getCurrentYear()[1];
                            e.setHours(23);
                            e.setMinutes(59);
                            e.setSeconds(59);
                            picker.$emit("pick", [s, e, 1]);
                        },
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            picker.$emit("pick", [start, end, 1]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            picker.$emit("pick", [start, end, 1]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            picker.$emit("pick", [start, end, 1]);
                        },
                    },
                ],
            },
            querydate: "",
            columns: [
                {
                    label: "序号",
                    value: "index",
                    align: "center",
                    type: "index",
                    width: 100,
                },
                {
                    label: "操作时间",
                    value: "auth_time",
                    align: "center",
                },
                {
                    label: "操作类型",
                    value: "AuthCmdName",
                    align: "center",
                },
                { label: "操作人", value: "CreateUserName", align: "center" }
            ],
            width: 1920,
            listQuery: {
                pageIndex: 1,
                pageSize: 15,
                orderColumn: "",
                orderbyasc: false,
                querymodel: {
                    keyword: "",
                    auth_user_id: "",
                    cmd_user_id: "",
                    auth_cmdtype: "",
                    begintime: "",
                    endtime: "",
                },
            },
            servicetime: 0,
        };
    },
    created() {
        try {
            let userinfo = JSON.parse(window.localStorage.getItem("user"));
            let stime = userinfo.syspara.filter((it) => it.ParaKey === "ht17")[0]
                .ParaValue;
            let ssstime = new Date(stime);
            let sstime = new Date();
            sstime.setSeconds(0);
            sstime.setHours(ssstime.getHours());
            sstime.setMinutes(ssstime.getMinutes());
            if (sstime.getTime() < new Date().getTime()) {
                this.servicetime = sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000;
            } else {
                this.servicetime = -(3600 * 1000 * 24 -
                    (sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000));
            }
        } catch {
            this.servicetime = 0;
        }
        this.width = document.documentElement.clientWidth;
        const end = new Date();
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        start.setTime(start.getTime() + this.servicetime);
        end.setTime(end.getTime() + this.servicetime);
        this.querydate = [start, end];
        this.listQuery.querymodel.begintime = start;
        this.listQuery.querymodel.endtime = end;
        queryemp({
            pageIndex: 1,
            pageSize: 10000,
            orderColumn: "",
            orderbyasc: false,
            querymodel: {
                EnableMark: -1,
                ShopMark: -1,
                keyword: "",
                AdminMark: true,
            },
        }).then((res) => {
            this.emplist = res.data;
        });
        this.getList();
    },
    methods: {
        authcmdtypechange(value) {
            switch (value) {
                case "":
                    this.columns = [
                        {
                            label: "序号",
                            value: "index",
                            align: "center",
                            type: "index",
                            width: 100
                        },
                        {
                            label: "操作时间",
                            value: "auth_time",
                            align: "center"
                        },
                        {
                            label: "操作类型",
                            value: "AuthCmdName",
                            align: "center",
                        },
                        { label: "操作人", value: "CreateUserName", align: "center" },
                    ];
                    break;
                case 1:
                    this.columns = [
                        {
                            label: "序号",
                            value: "index",
                            align: "center",
                            type: "index",
                            width: 100,
                        },
                        {
                            label: "操作时间",
                            value: "auth_time",
                            align: "center"
                        },
                        {
                            label: "操作类型",
                            value: "AuthCmdName",
                            align: "center",
                        },
                        { label: "操作人", value: "CreateUserName", align: "center" }
                    ];
                    break;
                case 2:
                    this.columns = [
                        {
                            label: "序号",
                            value: "index",
                            align: "center",
                            type: "index",
                            width: 100
                        },
                        {
                            label: "操作时间",
                            value: "auth_time",
                            align: "center"
                        },
                        {
                            label: "操作类型",
                            value: "AuthCmdName",
                            align: "center"
                        },
                        { label: "操作人", value: "CreateUserName", align: "center" },
                        {
                            label: "免除金额",
                            value: "del_amount",
                            align: "center",
                        },
                        {
                            label: "订单ID",
                            value: "del_sale_id",
                            align: "center",
                        }
                    ];
                    break;
            }
            this.getList();
        },
        datechange(item) {
            if (item.length === 3) {
                this.querydate = [item[0], item[1]];
                this.querydate[0].setTime(
                    this.querydate[0].getTime() + this.servicetime
                );
                this.querydate[1].setTime(
                    this.querydate[1].getTime() + this.servicetime
                );
            }
            this.listQuery.querymodel.begintime = this.querydate[0];
            this.listQuery.querymodel.endtime = this.querydate[1];
            this.getList();
        },
        callFunction(item) {
            this[item.BtnCode].apply(this, item);
        },
        savecomplete() {
            this.dialogshow = false;
            this.getList();
        },
        cancelcomplete() {
            this.dialogshow = false;
        },
        getList(item) {
            if (item != null && item != undefined) {
                this.listQuery.pageIndex = item.page;
                this.listQuery.pageSize = item.limit;
            } else {
                this.listQuery.pageIndex = 1;
            }
            getauthlogmv(this.listQuery).then((res) => {
                this.list = res.data;
                this.total = res.dataCount;
            });
        },
        m_export() {
            this.downloadLoading = true;
            import("@/vendor/Export2Excel").then((excel) => {
                const tHeader = [];
                const filterVal = [];
                this.columns.forEach((item) => {
                    tHeader.push(item.label);
                    filterVal.push(item.value);
                });
                const exportquery = JSON.parse(JSON.stringify(this.listQuery));
                let index = 1;
                exportquery.pageIndex = 1;
                exportquery.pageSize = 1000000;
                getauthlogmv(exportquery).then((res) => {
                    const data = res.data.map((v) =>
                        filterVal.map((j) => {
                            if (j === "index") {
                                return index++;
                            } else {
                                return v[j];
                            }
                        })
                    );
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: "风险操作日志",
                    });
                    this.downloadLoading = false;
                });
            });
        },
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
};
</script>